import routes from "./onboarding";

const handleUserAccessToPage = (userInfo) => {
  if (userInfo === null) {
    return false;
  }

  return userInfo.user.phone_verification_done;
};

const externalRoutes = routes.reduce((acc, route) => acc.set(route.name, {
  path: route.path,
  title: route.meta.pageTitle,
  authRequired: route.meta.authRequired,
  handleUserAccessToPage: route.meta.handleUserAccessToPage || handleUserAccessToPage,
}), new Map())

export default externalRoutes
